import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  tableCellClasses,
} from "@mui/material";
import React from "react";

import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";
import { GetUserOfficePostsResponse } from "../../../models/officePosts.model";
import { DeleteUserOfficePost } from "../../../services/officePosts.service";
import PermissionTableRows from "./PermissionTableRows";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
}));

interface Props {
  userOfficePostsList: GetUserOfficePostsResponse[];
  setUpdateGetUserOfficePosts: any;
  userId: number;
  setUpdateGetUserOfficePostById: any;
}
const PermissionTable = ({
  userOfficePostsList,
  setUpdateGetUserOfficePosts,
  userId,
  setUpdateGetUserOfficePostById,
}: Props) => {
  const { mutate: DeleteUserOfficePostMutate } = useMutation(
    DeleteUserOfficePost,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          // DATA STORE IN STATE

          toast.success("پست سازمانی با موفقیت حذف شد");
          setUpdateGetUserOfficePosts(uuid());
          setUpdateGetUserOfficePostById(uuid());
        }
      },
      onError: () => {},
    }
  );

  const handelDeleteItem = (id: number) => {
    DeleteUserOfficePostMutate({
      userId: userId,
      userOfficePostId: id,
    });
  };

  const columns = [
    {
      id: 1,
      title: "پست سازمانی",
    },
    {
      id: 2,
      title: "تاریخ اعطا",
    },
    {
      id: 3,
      title: "کاربر اعطا کننده",
    },
  ];

  return (
    <>
      <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
        <Table
          stickyHeader
          sx={{ minWidth: { xs: 0, sm: 0, md: 700, lg: 900 } }}
          aria-label="customized table"
        >
          <TableHead>
            <TableRow>
              {columns.length > 0 &&
                columns.map((column) => (
                  <StyledTableCell align="center">
                    {column.title}
                  </StyledTableCell>
                ))}
              <StyledTableCell align="center">
                <MoreHorizIcon />
              </StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody
            sx={{
              outline: "1px solid #DAE0E4",
            }}
          >
            {userOfficePostsList?.length !== 0 &&
              userOfficePostsList
                ?.map((post: any, index: number) => (
                  <PermissionTableRows
                    item={post}
                    handelDeleteItem={handelDeleteItem}
                  />
                ))
                .reverse()}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default PermissionTable;
